import * as cartActionTypes from "ActionTypes/cartActionTypes";
import cartInitialState from "InitialStates/cartInitialState";

const reducers = {
  setCart: (state, action) => {
    return {
      ...state,
      cart: action.cart
    };
  },
  clearCart: (state, action) => {
    return {
      ...state,
      cart: action.cart
    };
  }
};

const cartReducer = (state = cartInitialState, action) => {
  switch (action.type) {
    case cartActionTypes.DEC_CART:
    case cartActionTypes.UPDATE_CART:
    case cartActionTypes.SET_CART:
      return reducers.setCart(state, action);
    case cartActionTypes.CLEAR_CART:
      return reducers.clearCart(state, action);
    default:
      return state;
  }
};

export default cartReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/cartReducer.js